{
  "name": "CEO Wisdom",
  "nameWithArticle": "a CEO Wisdom",
  "tagline": "CEO Intelligence Platform",
  "formerNames": ["Edify"],
  "company": "Edify"
}
